/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_TitleInputs */

const en_us2_exercise_personal_info_title = /** @type {(inputs: Exercise_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How a goal is measured`)
};

const pt_br2_exercise_personal_info_title = /** @type {(inputs: Exercise_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a meta é medida`)
};

const es_419_exercise_personal_info_title = /** @type {(inputs: Exercise_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo se mide una meta`)
};

const pt_pt2_exercise_personal_info_title = /** @type {(inputs: Exercise_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o objetivo é medido`)
};

const fr_fr2_exercise_personal_info_title = /** @type {(inputs: Exercise_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment un objectif est mesuré`)
};

const de_de2_exercise_personal_info_title = /** @type {(inputs: Exercise_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie ein Ziel gemessen wird`)
};

const it_it2_exercise_personal_info_title = /** @type {(inputs: Exercise_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si misura un obiettivo`)
};

/**
* | output |
* | --- |
* | "How a goal is measured" |
*
* @param {Exercise_Personal_Info_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_title = /** @type {((inputs?: Exercise_Personal_Info_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_title(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_title(inputs)
	return en_us2_exercise_personal_info_title(inputs)
});
export { exercise_personal_info_title as "exercise-personal.info_title" }